import React from "react";
import { OutlinedInput, Checkbox, FormControlLabel } from "@material-ui/core";
import InfoOutlined from "@material-ui/icons/InfoOutlined";

import {
  TEMPLATE_KEYS,
  TemplateConfig,
  SidebarConfig,
} from "../../../constants";
import placeholderImage from "assets/images/image-uploader-placeholder.png";
import { ABOUT_YOU_CONFIG } from "ui/pages/TemplatePreview/constants.js";
import { ErrorText, ImageUploader, RichTextInput } from "../../../widgets";
import constants from "constants/constants";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import {
  ABOUT_YOU_LABELS,
  ABOUT_YOU_PLACEHOLDERS,
  ABOUT_YOU_MESSAGES,
  ABOUT_YOU_DEFAULTS,
  ABOUT_YOU_DIMENSIONS,
  ABOUT_YOU_LINKS,
  ABOUT_YOU_FIELD_KEYS,
  ABOUT_YOU_ERROR_KEYS,
} from "../sidebar.constant";
import { useCreateAboutYouHandlers } from "./AboutYou/utils/useHandleAboutYou";

export const AboutYou = (props) => {
  const {
    state,
    setField,
    errorState,
    setErrorMessage,
    enableError,
    disableAllEdits,
    hiddenFields = [],
  } = props;

  const {
    handleDisplayImageUpload,
    handleDisplayNameChange,
    handleDisplayNameBlur,
    handleShortBioChange,
    handleShortBioBlur,
    handleSectionTitleChange,
    handleNavbarTitleChange,
    handleNavbarTitleBlur,
    handleBioTextChange,
    handleExpandCheckbox,
    handleExperienceYearsCountChange,
    handleExperienceYearsLabelChange,
    handleVideoChange,
    handleVideoBlur,
    showSectionTitle,
  } = useCreateAboutYouHandlers({
    state,
    setField,
    setErrorMessage,
    enableError,
    hiddenFields,
  });

  return (
    <>
      {state?.template?.slug === TEMPLATE_KEYS.ELEMENTARY ? null : (
        <div className="tw-py-1">
          <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
            {ABOUT_YOU_LABELS.DISPLAY_PICTURE}
          </div>
          <div className="tw-my-1.5 tw-relative">
            <ImageUploader
              uploadUrl={
                state.display_image === constants.null_display_image
                  ? ""
                  : state.display_image
              }
              setUploadUrl={handleDisplayImageUpload}
              customDefaultImage={placeholderImage}
              hoverText={ABOUT_YOU_LABELS.UPLOAD_DISPLAY_IMAGE}
              fullWidth={ABOUT_YOU_DIMENSIONS.IMAGE_FULL_WIDTH}
              width={ABOUT_YOU_DIMENSIONS.IMAGE_WIDTH}
              height={ABOUT_YOU_DIMENSIONS.IMAGE_HEIGHT}
              borderRadius={ABOUT_YOU_DIMENSIONS.IMAGE_BORDER_RADIUS}
              query={ABOUT_YOU_DEFAULTS.IMAGE_QUERY}
              id="display_image_mypage"
              disabled={disableAllEdits}
              uploadViaOptimization
              sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
            />
          </div>
        </div>
      )}

      <div className="tw-py-1">
        <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0 after:tw-ml-1 after:tw-content-['*'] after:tw-text-[#e83f6f] after:tw-text-base after:tw-leading-3">
          {ABOUT_YOU_LABELS.YOUR_NAME}
        </div>
        <div className="tw-my-1.5 tw-relative">
          <OutlinedInput
            className="tw-w-full tw-rounded"
            value={state?.display_name}
            name="display_name"
            disabled={disableAllEdits}
            inputProps={{ maxLength: ABOUT_YOU_CONFIG.MAX_NAME_LENGTH }}
            onChange={handleDisplayNameChange}
            onBlur={handleDisplayNameBlur}
          />
          <ErrorText errorState={errorState} fieldKey="display_name" />
        </div>
      </div>

      {SidebarConfig.showGetInTouchSection.includes(state?.template?.slug) ? (
        <div className="tw-py-1">
          <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
            {ABOUT_YOU_LABELS.SHORT_BIO}
          </div>
          <div className="tw-my-1.5 tw-relative">
            <OutlinedInput
              className="tw-w-full tw-rounded"
              value={state?.social_info?.website_desc}
              name="short_description"
              disabled={disableAllEdits}
              inputProps={{
                maxLength: ABOUT_YOU_CONFIG.MAX_DESC_LENGTH,
              }}
              onChange={handleShortBioChange}
              onBlur={handleShortBioBlur}
            />
            <ErrorText errorState={errorState} fieldKey="website_desc" />
          </div>
        </div>
      ) : null}

      {showSectionTitle(ABOUT_YOU_FIELD_KEYS.SECTION_TITLE) && (
        <div className="tw-py-1">
          <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
            {ABOUT_YOU_LABELS.SECTION_TITLE}
          </div>
          <div className="tw-my-1.5 tw-relative">
            <OutlinedInput
              className="tw-w-full tw-rounded"
              value={
                state?.social_info?.about_section_title ||
                ABOUT_YOU_DEFAULTS.ABOUT_YOU
              }
              disabled={disableAllEdits}
              onChange={handleSectionTitleChange}
            />
          </div>
        </div>
      )}

      {showSectionTitle(ABOUT_YOU_FIELD_KEYS.NAVBAR_TITLE) && (
        <div className="tw-py-1">
          <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
            {ABOUT_YOU_LABELS.NAVBAR_TITLE}
          </div>
          <div className="tw-my-1.5 tw-relative">
            <OutlinedInput
              className="tw-w-full tw-rounded"
              value={
                state?.lead_keys?.about_title ||
                state?.custom_headings?.about_title ||
                state?.navbar_titles?.about_title ||
                ABOUT_YOU_DEFAULTS.ABOUT
              }
              disabled={disableAllEdits}
              inputProps={{
                maxLength: ABOUT_YOU_CONFIG.MAX_NAVBAR_TITLE_LENGTH,
              }}
              onChange={handleNavbarTitleChange}
              onBlur={handleNavbarTitleBlur}
            />
            <ErrorText
              errorState={errorState}
              fieldKey={ABOUT_YOU_ERROR_KEYS.ABOUT_TITLE}
            />
          </div>
        </div>
      )}

      {showSectionTitle(ABOUT_YOU_FIELD_KEYS.BIO_TEXT) && (
        <div className="tw-py-1">
          <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
            {ABOUT_YOU_LABELS.ABOUT_YOU}
          </div>
          <div className="tw-my-1.5 tw-relative">
            <RichTextInput
              value={state?.bio_text}
              onChange={handleBioTextChange}
              readOnly={disableAllEdits}
            />
          </div>

          <div className="tw-mt-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!state?.lead_keys?.expand_host_desc}
                  onChange={handleExpandCheckbox}
                  disabled={disableAllEdits}
                  color="primary"
                />
              }
              label={ABOUT_YOU_LABELS.READ_MORE_CLOSED}
            />
          </div>
        </div>
      )}

      {state?.template?.slug === TEMPLATE_KEYS.YOGA ? (
        <>
          <hr />
          <div
            className="tw-text-[#818e9e] tw-text-sm tw-font-normal tw-leading-[18px] tw-tracking-[0.28px]"
            style={{ fontFamily: ABOUT_YOU_DEFAULTS.FONT_FAMILY }}
          >
            <InfoOutlined className="tw-w-4 tw-h-4 tw-mr-1 tw-inline" />
            {ABOUT_YOU_MESSAGES.EXPERIENCE_BOX_INFO}
          </div>

          <div className="tw-py-1">
            <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
              {ABOUT_YOU_LABELS.EXPERIENCE_YEARS}
            </div>
            <div className="tw-my-1.5 tw-relative">
              <OutlinedInput
                className="tw-w-full tw-rounded"
                placeholder={ABOUT_YOU_PLACEHOLDERS.KEEP_SHORT}
                disabled={disableAllEdits}
                name="experience_years_count"
                value={state?.social_info?.experience_years_count}
                onChange={handleExperienceYearsCountChange}
              />
            </div>
          </div>

          <div className="tw-py-1">
            <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
              {ABOUT_YOU_LABELS.EXPERIENCE_LABEL}
            </div>
            <div className="tw-my-1.5 tw-relative">
              <OutlinedInput
                className="tw-w-full tw-rounded"
                disabled={disableAllEdits}
                placeholder={ABOUT_YOU_PLACEHOLDERS.EXPERIENCE_EXAMPLE}
                value={state?.social_info?.experience_years_label}
                name="experience_years_label"
                onChange={handleExperienceYearsLabelChange}
              />
            </div>
          </div>
        </>
      ) : null}

      {TemplateConfig?.[state?.template?.slug]?.introVideo ? (
        <>
          <div className="tw-py-1">
            <div className="tw-font-bold tw-text-[#666] tw-tracking-[0.2px] tw-text-sm tw-mt-1 tw-mb-0">
              {ABOUT_YOU_LABELS.INTRO_VIDEO}
            </div>
            <div className="tw-my-1.5 tw-relative">
              <OutlinedInput
                className="tw-w-full tw-rounded"
                value={state?.social_info?.video}
                name="video"
                disabled={disableAllEdits}
                onChange={handleVideoChange}
                onBlur={handleVideoBlur}
              />
              <ErrorText errorState={errorState} fieldKey="video" />
            </div>
            <div className="tw-py-1">
              <div
                className="tw-text-[#818e9e] tw-text-sm tw-font-normal tw-leading-[18px] tw-tracking-[0.28px]"
                style={{ fontFamily: ABOUT_YOU_DEFAULTS.FONT_FAMILY }}
              >
                {ABOUT_YOU_MESSAGES.VIDEO_HELP_TEXT}&nbsp;
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={ABOUT_YOU_LINKS.YOUTUBE_UPLOAD_HELP}
                  className="tw-text-[#6c5dd3]"
                >
                  {ABOUT_YOU_LABELS.HOW_TO_UPLOAD}
                </a>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
